<template>
  <div class="box">

    
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card>
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
              <a-form layout="inline">
                  <a-row :gutter="24">
                  <a-col :md="6">
                      <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                          <a-input placeholder="请输入单据编号" v-model="queryParam.code"></a-input>
                          </a-form-item>
                      </a-col>
                      <!-- <a-col :md="6">
                          <a-form-item label="开始结束日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                              <a-range-picker
                                  style="width: 100%"
                                  v-model="queryParam.date"
                                  :default-value="defaultTimeStr"
                                  format="YYYY-MM-DD"
                                  :placeholder="['开始时间', '结束时间']"
                                  @change="onDateChange"
                              />
                          </a-form-item>
                      </a-col> -->
                      <a-col :md="6">
                          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                          <a-col :md="6" :sm="24">
                              <a-button type="primary" @click="searchQuery">查询</a-button>
                              <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                          </a-col>
                          </span>
                      </a-col>
                  </a-row>
              </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator"  style="margin-top: 5px">
            <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
          </div>

          <!-- table区域-begin -->
          <div>
              <a-table
                  ref="table"
                  size="middle"
                  bordered
                  rowKey="uuid"
                  :columns="columns"
                  :dataSource="dataSource"
                  :pagination="ipagination"
                  @change="handleTableChange"
              >
              <template slot="state" slot-scope="state">
                <a-tag color="red" v-if="state === 0">未审核</a-tag>
                  <a-tag color="blue" v-else-if="state === 1">审核中</a-tag>
                  <a-tag color="green" v-else-if="state === 2">审核通过</a-tag>
                  <a-tag color="red" v-else-if="state === 3">未通过审核</a-tag>
              </template>
              <template slot="action" slot-scope="text, record">
                  <a @click="handleEdit(record)"
                    :disabled="record.state !== 0"
                    :style="{ cursor: record.state !== 0 ? 'not-allowed' : 'pointer', opacity: record.state !== 0 ? 0.5 : 1 }"
                  >修改</a>
                  <a-divider type="vertical" />
                  <a @click="handleAfterDetail(record)">查看</a>
                  <a-divider type="vertical" />
                  <a 
                    @click="handleVerify(record)"
                    :disabled="record.state !== 0"
                    :style="{ cursor: record.state !== 0 ? 'not-allowed' : 'pointer', opacity: record.state !== 0 ? 0.5 : 1 }"
                  >审核</a>
                  <a-divider type="vertical" />
                  <a @click="handleDelete(record)"
                  :disabled="record.state !== 0"
                  :style="{ cursor: record.state !== 0 ? 'not-allowed' : 'pointer', opacity: record.state !== 0 ? 0.5 : 1 }"
                  >删除</a>
              </template>
              </a-table>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <!-- 新增/编辑区域 -->
    <addAdverseEvent ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></addAdverseEvent>
    <adverse-detail ref="adverseDetail" @ok="afterDetailOk" @close="afterDetailClose"></adverse-detail>

  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAdverseList, deleteAdverse, updateAdverseStatus, getAdverseDetail } from '@/api/api'
  import addAdverseEvent from './modules/addAdverseEvent'
  import AdverseDetail from './modules/adverseDetail'
  export default {
    name: "list",
    mixins:[JeecgListMixin],
    components: {
      addAdverseEvent,
      AdverseDetail
    },
    data() {
      return {
        current: ['enterpriseRule'], // 顶部导航栏
        bindInfo:{},
        // 查询区域布局
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18,
          offset: 1
        },

        // 查询条件
        queryParam: {},
        menuItems: [],
        dropdownStates: {},
        dropdownVisible: false, // 控制下拉框的显示状态
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width: '50px',
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
              title: '审核结果', 
              dataIndex: 'state', 
              align:"center", 
              scopedSlots: { customRender: 'state' },render: (text) => text || "--",
              sorter: (a, b) => a.state - b.state
          },
          {
              title: '单据编号', 
              dataIndex: 'code', 
              align:"center",
              sorter: (a, b) => a.code.localeCompare(b.code),
          },
          {
              title: '产品编号', 
              dataIndex: 'productNumber', 
              align:"center",
              sorter: (a, b) => a.productNumber.localeCompare(b.productNumber),
          },
          {
              title: '产品名称', 
              dataIndex: 'productName', 
              align:"center",
              sorter: (a, b) => a.productName.localeCompare(b.productName),
          },
          {
              title: '服务时间', 
              dataIndex: 'date', 
              align:"center",
              sorter: (a, b) => a.date.localeCompare(b.date),
          },
          {
              title: '受理人', 
              dataIndex: 'acceptedBy', 
              align:"center",
              sorter: (a, b) => a.acceptedBy.localeCompare(b.acceptedBy),
          },
          {
              title: '审核人',
              dataIndex: 'reviewer',
              align:"center",
              sorter: (a, b) => new Date(a.reviewer) - new Date(b.reviewer),
          },
          {
              title: '审核备注', 
              dataIndex: 'reviewRemark', 
              align:"center",
              sorter: (a, b) => a.reviewRemark.localeCompare(b.reviewRemark),
          },
          {
              title: '操作',
              dataIndex: 'action',
              align:"center",
              scopedSlots: { customRender: 'action' },
              width: '250px'
          }
          
        ],
        dataSource:[],
        // 控制列的显示状态
        columnVisibility: {
          codeRuleId: false, // 设置为 false 隐藏该列
          formTemplateId: false, // 设置为 false 隐藏该列
          proceCode: false
        },
      ipagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showTotal: (total) => `共 ${total} 条`,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30'],
          onShowSizeChange: (current, pageSize) => this.onShowSizeChange(current, pageSize),
      },
      url: {
        list: '', ///quality/afterSales/list
      },
      }
    },
    mounted() {
      this.getAdverseList();
    },
    methods: {
      
      // 获取售后列表
      async getAdverseList(){
        
        const params = {
          code: this.queryParam.code || '',
          date: this.queryParam.date || '',
          pageSize: this.ipagination.pageSize,
          pageNo: this.ipagination.current
        }
        const res = await getAdverseList(params)
        if(  res.code == 200 && res.success == true ){
          console.log(res,'售后服务res====================')
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.warning(res.message)
        }
      },
      getColor(state) {
          if ( state == 1 ) return '处理中'
          else if ( state == 2 ) return '上传成功'
          else if ( state == 3 ) return '上传失败'
          else return '未知状态'
      },
      handleTableChange(pagination, filters, sorter) {
          this.ipagination = pagination;
          this.getAdverseList();
      },
      searchQuery() {
          console.log('查询条件:', this.queryParam);
          this.getAdverseList();
      },
      searchReset() {
          this.queryParam = {};
          this.getAdverseList();
      },
      onShowSizeChange(current, pageSize) {
          this.ipagination.current = current;
          this.ipagination.pageSize = pageSize;
          // 重新获取数据或处理分页逻辑
      },
      handleEdit(record){
        this.$refs.modalForm.edit(record)
      },
      modalFormOk(){
        this.getAdverseList()
      },
      // 上传
      async uploadOrder(record){
        const params = {
          recordId: record.id
        }
        const res = await traceSaveForEventId(params)
        if(  res.code == 200 && res.success == true ){
          this.$message.success(res.message)
          this.getAdverseList()
        } else {
          this.$message.warning(res.message)
        }
      },
      // 查看
      async handleAfterDetail(record){
        const res = await getAdverseDetail({id:record.id})
        if( res.code == 200 && res.success == true ){
          this.$refs.adverseDetail.show(res.result)
        } else {
          this.$message.error(res.message)
        }
      },
      // 审核
      async handleVerify(record){
        const params = {
          id: record.id,
        }
        const res = await updateAdverseStatus(params)
        if( res.code == 200 && res.success == true ){
          this.$message.success(res.message)
          this.getAdverseList()
        } else {
          this.$message.warning(res.message)
        }
      },
      // 删除
      handleDelete(record){
        this.$confirm('是否确定删除', '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.deleteAdverse(record)
        }).catch(() => {});
      },
      async deleteAdverse(record){
        const params = {
          id: record.id
        }
        const res = await deleteAdverse(params)
        if( res.code == 200 && res.success == true ) {
          this.$message.success(res.message)
          this.getAdverseList()
        } else {
          this.$message.error(res.message)
        }
      }
    },
  }
</script>

<style scoped>

</style>